import { useQueryClient, useMutation, } from "@tanstack/react-query";
import { useAuthApiClient } from "./useAuthApiClient";
import { QUERY_KEYS } from "./constants";
export function useLinkAccount(mutationOptions = {}) {
    const queryClient = useQueryClient();
    const authApiClient = useAuthApiClient();
    const { onSuccess: customOnSuccess, ...restMutationOptions } = mutationOptions;
    const { mutate, mutateAsync, ...rest } = useMutation({
        mutationFn: (linkAccountRequest) => authApiClient.linkAccount(linkAccountRequest),
        onSuccess: (data, variables, context) => {
            queryClient.resetQueries({ queryKey: [QUERY_KEYS.ACCOUNT] });
            if (customOnSuccess)
                customOnSuccess(data, variables, context);
        },
        ...restMutationOptions,
    });
    return { linkAccount: mutate, linkAccountAsync: mutateAsync, ...rest };
}
//# sourceMappingURL=useLinkAccount.js.map